import moment from 'moment-timezone';

const TimezoneClock = ({ timezone, label, timeFormat,dateTime }) => {
  return (
    moment.tz(dateTime, timezone).format(timeFormat)
  );
};

export default TimezoneClock;